export const ErnotsConfig =
{
    /** The name of the application, to appear at the top. */
    AppName: process.env.REACT_APP_AppName,
    /** The name of the application, to appear at the top. */
    AppNameLong: process.env.REACT_APP_AppNameLong,
    /** The URL prefix for links to other parts of the front end. */
    BaseURL: process.env.REACT_APP_BaseURL,
    /** The URL prefix for the backend API. */
    APIURLPrefix: process.env.REACT_APP_APIURLPrefix,
    /** The URL prefix for the Djoser endpoints. */
    AuthURLPrefix: process.env.REACT_APP_AuthURLPrefix,
}

/** A function that uniformly formats page titles. */
export function GetPageTitle(title: string)
{
    if (!title.trim())
    {
        return ErnotsConfig.AppName;
    }
    
    return title + ' - ' + ErnotsConfig.AppNameLong;
}